/**
 * Firing a Trailblazers config write and collecting its outcome.
 *
 * Each game-level config (stalemate clues, radar ranges, treasure list, …) has
 * its own socket event with an ack callback, and both surfaces that write them —
 * the Game Settings modal and a bundle import — need the same thing: run several
 * independent writes together, then report which ones failed rather than
 * chaining and leaving the outcome ambiguous.
 */

/** The ack shape every `TRL_UPDATE_*_CONFIG` event replies with. */
interface ConfigWriteAck {
  success: boolean;
  error?: string;
}

/**
 * Promisify one config write. Resolves with `null` on success, or a user-facing
 * message naming what failed — so a batch can be gathered with `Promise.all`
 * and the failures filtered out of the results.
 *
 * @param label how the config reads in an error message, e.g. "radar ranges"
 */
export function emitConfigWrite(
  fn: (cb: (resp: ConfigWriteAck) => void) => void,
  label: string,
): Promise<string | null> {
  return new Promise((resolve) => {
    fn((resp) => resolve(resp.success ? null : (resp.error ?? `Failed to save ${label}`)));
  });
}
